export enum NdaTermSelectionType {
    DataNdaTerms
}